<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar 
      title="天堂纪念网服务协议" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->
    
    <div class="padding">
      <div v-if="html" v-html="html" ></div>
      <!-- <div class="title">天堂纪念网服务协议</div>
      <div class="details">
        <h2>一、服务协议的确认和范围</h2>
        <p>本协议是用户与天堂纪念网之间关于其使用天堂纪念网服务所订立的协议。“天堂纪念网”是指天堂纪念网服务的经营者。“用户”是指天堂纪念网服务的使用人，在本协议中更多地称为“您”。“天堂纪念网服务”是指天堂纪念网所属所有平台的一切服务（包挂但不限于在天堂纪念网网中列明天堂纪念网所属平台的网站、APP、小程序、公众号、其他客户端、其他服务等）。本协议由您与天堂纪念网共同缔结，本协议对您与天堂纪念网均具有合同效力。</p>
        <p>本协议项下，天堂纪念网服务的经营者可能根据业务调整而发生变更，变更后的天堂纪念网服务经营者与您共同履行本协议并向您提供服务，天堂纪念网服务经营者的变更不会影响您在本协议项下的权益。天堂纪念网服务经营者还有可能因为提供新的天堂纪念网服务而新增，如您使用新增的天堂纪念网服务的，视为您同意新增的天堂纪念网服务经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。</p>
        <p>由于互联网高速发展，您与天堂纪念网签署的本协议列明的条款并不能完整罗列并覆盖您与天堂纪念网所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，天堂纪念网后续公布的法律声明、隐私政策、各单项服务公告的条款规则等均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用天堂纪念网服务，视为您同意上述补充协议。</p>
        <p>本协议的效力范围涵盖天堂纪念网所属所有平台的一切服务，您在享受天堂纪念网任何单项服务时，应当受本协议条款的约束。</p>
        <p>当您通过进入天堂纪念网注册程序并完成注册，即表示您与天堂纪念网已达成协议，自愿接受本协议的所有内容。</p>
        <p>当您未经天堂纪念网注册程序而使用天堂纪念网服务，亦表示您同意并接受本协议的所有内容。</p>
        <p>当您使用天堂纪念网各单项服务，您的使用行为视为您对该单项服务的服务条款以及天堂纪念网在该单项服务中发出的各类公告的同意。</p>
        <p>天堂纪念网对本协议的名词定义具有解释权。</p>
        <h2>二、服务简介</h2>
        <p>● 天堂纪念网服务涉及到的产品所有权以及相关软件的知识产权归天堂纪念网所有。</p>
        <p>天堂纪念网运用网络平台通过国际互联网络为您提供网络服务，您应同意以下条款：</p>
        <p>1.提供准确的个人资料，并及时更新注册资料。</p>
        <p>2.您将对用户名和密码的安全性负全部责任，并对其用户名下的所有活动负全责。</p>
        <p>3.您对服务的使用应遵守国家法律、地方法规和国际法律。</p>
        <p>4.您同意保障和维护全体用户的利益，负责支付由于您违反本协议引起的律师费用、损害补偿费等。</p>
        <p>● 尊重个人隐私，天堂纪念网不公开您非公开信息，除以下情况外：
        <p>1.您主动公开或授权透露的信息。</p>
        <p>2.相应的法律及程序要求提供您的个人资料。</p>
        <p>3.在紧急情况下维护用户个人和社会大众的安全。</p>
        <p>4.保持维护天堂纪念网的各项权利。</p>
        <p>●如果您提供的资料包含有不正确的信息，天堂纪念网保留结束您使用网络服务资格的权利。天堂纪念网保留判定您的行为是否符合本服务协议的权利。</p>
        <h2>三、服务协议的修改</h2>
        <p>天堂纪念网有权单方面修改本协议以及相关补充协议。您在享受天堂纪念网服务时，应当及时查阅了解修改的内容，并自觉遵守本协议以及相关补充协议。</p>
        <h2>四、服务修订</h2>
        <p>天堂纪念网保留随时修改或中断服务而不需通知您的权利。您需接受天堂纪念网行使修改或中断服务的权利，天堂纪念网不需对您或第三方负责。</p>
        <h2>五、用户隐私制度</h2>
        <p>天堂纪念网制定并在天堂纪念网网公布了天堂纪念网隐私政策，天堂纪念网在必要时可修改隐私政策，您应及时阅读并遵守相关条款。</p>
        <h2>六、用户的帐号、密码和安全性</h2>
        <p>您一旦注册成功，您将得到一个密码和帐号。如果您未保管好自己的帐号和密码而对您、天堂纪念网或第三方造成的损害，您将负全部责任。另外，每个用户都要对其帐户中的所有活动和事件负全责。您可随时改变您的密码和信息，也可以结束旧的帐户重开一个新帐户。您同意若发现任何非法使用用户帐号或安全漏洞的情况，立即通知天堂纪念网。</p>
        <h2>七、拒绝提供担保和免责声明</h2>
        <p>您明确同意使用天堂纪念网服务的风险由您个人承担。天堂纪念网明确表示不提供任何类型的担保，不论是明确的或隐含的。天堂纪念网不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性、安全性、真实性、出错发生都不作担保。天堂纪念网网拒绝提供任何担保，包括信息能否准确、及时、顺利地传送。您理解并接受下载或通过天堂纪念网服务取得的任何信息资料取决于您自己，并由您承担系统受损、资料丢失以及其它任何风险。</p>
        <h2>八、有限责任</h2>
        <p>天堂纪念网对直接、间接、偶然、特殊及继起的损害不负责任，这些损害来自：不正当使用产品服务，非法使用服务或用户发布不良信息。这些损害会导致天堂纪念网形象受损，所以天堂纪念网早已提出这种损害的可能性。</p>
        <h2>九、用户管理</h2>
        <p>您单独承担发布内容的责任。您对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。您承诺：</p>
        <p>Ⅰ、您单独承担发布内容的责任。您对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。您承诺：</p>
        <p>1.违反宪法确定的基本原则的；</p>
        <p>2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p>3.损害国家荣誉和利益的；</p>
        <p>4.煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p>5.破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p>6.散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p>7.散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
        <p>8.侮辱或者诽谤他人，侵害他人合法权益的；</p>
        <p>9.煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
        <p>10.以非法民间组织名义活动的；</p>
        <p>11.含有法律、行政法规禁止的其他内容的。</p>
        <p>Ⅱ、在天堂纪念网平台上发布信息或者利用天堂纪念网服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。</p>
        <p>Ⅲ、不利用天堂纪念网服务从事以下活动：</p>
        <p>1.未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
        <p>2.未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
        <p>3.未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
        <p>4.故意制作、传播计算机病毒等破坏性程序的；</p>
        <p>5.其他危害计算机信息网络安全的行为。</p>
        <p>Ⅳ、不以任何方式干扰天堂纪念网的服务。</p>
        <p>Ⅴ、遵守天堂纪念网的所有其他规定和程序。</p>
        <p>遵守天堂纪念网的所有其他规定和程序。</p>
        <p>用户使用天堂纪念网网博客和留言板等以交互形式为上网用户提供信息发布条件的行为，也须遵守本条的规定以及天堂纪念网网将专门发布的电子公告服务规则，上段中描述的法律后果和法律责任同样适用于电子公告服务的用户。若用户的行为不符合以上提到的服务条款，天堂纪念网网将作出独立判断立即取消用户服务帐号。</p>
        <p>您使用天堂纪念网平台以交互形式为上网用户提供信息发布条件的行为，也须遵守本条的规定以及专门的相关规定，上段中描述的法律后果和法律责任同样适用。若您的行为不符合以上提到的服务条款，天堂纪念网将作出独立判断立即取消您服务帐号。</p>
        <h2>十、保障</h2>
        <p>您同意保障和维护天堂纪念网服务全体成员的利益，负责支付由您或其账号使用人使用超出服务范围引起的律师费用，违反服务协议条款的损害赔偿费用。您或者使用您帐号的其他人在使用过程中侵犯第三方知识产权及其他权利而导致被侵权人索赔的，由您承担责任。</p>
        <h2>十一、结束服务</h2>
        <p>您或天堂纪念网可随时根据实际情况中断服务。天堂纪念网有权单方不经通知终止向您提供某一项或多项服务；您有权单方不经通知终止接受天堂纪念网的服务。结束服务后，您使用天堂纪念网服务的权利立即终止。从那时起，天堂纪念网网不再对您承担任何义务。</p>
        <h2>十二、特别提醒</h2>
        <p>1.天堂纪念网服务中所涉到的所有收费，限于天堂纪念网服务使用费，不涉及任何捐款、捐助、捐赠或利用天堂纪念网服务所实施的第三方捐款、捐助、捐赠行为。</p>
        <p>2.天堂纪念网为互联网应用软件开发商，用户在使用天堂纪念网服务过程中的活动均为用户独立自主、自愿、自发行为，天堂纪念网本身不参与任何宗教、政治等相关立场的引导、建议及活动。</p>
        <p>3.由于使用天堂纪念网服务过程中的文字发表及图片上传的特性，您公布的文字或图片如不被您设为隐藏都会成为公开的信息。因此，我们提醒并请您慎重考虑是否有必要公开您的个人信息及图片。您享有编辑、删除文字及图片的权利。同时我们保留随时删除不健康文字信息及图片并终止服务的权利。对于由于您自身的操作所造成的文字或图片的丢失,天堂纪念网将不负任何责任。</p>
        <p>4.天堂纪念网服务中涉及到的充值、有期限或无期限的VIP权限功能以及其他收费功能等，天堂纪念网有权单方面因时代技术的进步优化用户体验或是不可抗力的因素等原因进行变更或终止，已经收取的费用不再退还。</p>
        <h2>十三、服务协议修改及生效</h2>
        <p>本协议以及相关补充协议经用户注册或使用服务时生效。如有修改，修改的内容将在天堂纪念网网中公布，用户有权选择是否继续使用天堂纪念网服务，若用户继续使用，视为同意修改后的协议。</p>
      </div> -->
    </div>

  </div>
</template>

<script>
	export default {
	  data() {
	    return {
	    	html : null,
	    };
	  },
	  components: {
    },
    
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
      },
      init(){
        var that = this;
        this.$store.dispatch({
          type:"HtmlInfoGetHtmlInfoByKeyName",
          KeyName : "用户协议"
        }).then(res => {
          that.html = res;
        }, err => {})
      }
    },
    // 
    created(){
      this.init();
    }
	};
</script>

<style scoped>
.padding{
  padding: 15px 10px;;
}
.padding .title{
  font-weight: normal;
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
}
.details h2{
  font-size: 15px;
  font-weight: bold;
  margin-top: 18px;
  margin-bottom: 6px;
}
.details p{
  font-size: 14px;
  margin-bottom: 8px;
  line-height: 1.5;
}
</style>
